import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Field } from '../form/Field';
import { VFFilterFieldProps } from '../form/types';
import { FilterItem } from './FilterItem';
import classNames from 'classnames';
import { FilterFieldProps, getFilterFieldFormValuePath } from './types';
import { DateTimeInput } from '../datetime/DateTimeInput';
import { DATA_FILTER_INPUT } from '../common/data';

export type NumberProps = VFFilterFieldProps<
  React.ComponentProps<typeof DateTimeInput> & FilterFieldProps
>;
export const FilterDateTime = React.forwardRef<HTMLInputElement, NumberProps>(
  (
    {
      name,
      validate,
      className,
      inputClassName,
      label,
      required,
      disabled,
      size = 15,
      filterType,
      extendedFilter,
      ...other
    },
    // @ts-ignore
    ref
  ) => {
    return (
      <FilterItem
        name={name}
        className={className}
        label={label}
        disabled={disabled}
        filterType={filterType}
        extendedFilter={extendedFilter}
      >
        <Field
          name={getFilterFieldFormValuePath(name, filterType)}
          validate={validate}
        >
          {({
            input: { value, onChange, name },
            meta,
          }: FieldRenderProps<number>) => {
            return (
              <DateTimeInput // @ts-ignore
                {...DATA_FILTER_INPUT(name)}
                {...other}
                inputProps={{ size }}
                disabled={disabled || meta.submitting}
                className={classNames(
                  `-date final-form-input-right-visual`,
                  inputClassName
                )}
                onChange={(newValue) => {
                  onChange({ target: { name, value: newValue } });
                }}
                // @ts-ignore
                value={value}
              />
            );
          }}
        </Field>
      </FilterItem>
    );
  }
);
